import { render, staticRenderFns } from "./ScrollListOfTasks.vue?vue&type=template&id=65461707&scoped=true&lang=pug"
import script from "./ScrollListOfTasks.vue?vue&type=script&lang=js"
export * from "./ScrollListOfTasks.vue?vue&type=script&lang=js"
import style0 from "./ScrollListOfTasks.vue?vue&type=style&index=0&id=65461707&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65461707",
  null
  
)

export default component.exports